import AdminNotificationAPI from "@/api/adminNotification";

export default {
  namespaced: true,
  state: {},
  actions: {
    sendErrorToAdmin({ commit }, data) {
      return AdminNotificationAPI.sendErrorToAdmin(data.message, data.jsonData).then(res => {
        console.info("Message with error was send to admin");
        return res;
      });
    },
  },
  mutations: {},
  getters: {},
};
